import {
  Box,
  Typography,
  Container,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const TermsAndConditions = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const sectionStyle = {
    marginBottom: theme.spacing(4),
  };

  const headingStyle = {
    fontWeight: 500,
    marginBottom: theme.spacing(1),
    fontFamily: "Outfit",
  };

  const paragraphStyle = {
    marginBottom: theme.spacing(1.2),
    fontFamily: "Outfit",
  };

  return (
    <Box
      sx={{
        backgroundColor: "white",
        fontFamily: "Outfit",
        // marginTop: "4%",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          sx={{ fontWeight: 550, mb: 1, fontFamily: "Outfit" }}
        >
          Terms & Conditions
        </Typography>

        <Typography sx={paragraphStyle}>
          Effective Date: July 01, 2025
        </Typography>

        <Typography sx={paragraphStyle}>
          Welcome to Atttic.com (“Website”), operated by Xculptor 3Dtech Private
          Limited (“Company”, “we”, “us”, or “our”). These Terms & Conditions
          (“Terms”) govern your access to and use of our Website and any
          Atttic-branded solutions, offerings, and services (collectively
          referred to as “Services”).
        </Typography>

        <Typography sx={paragraphStyle}>
          By accessing or using our Website or Services, you agree to be bound
          by these Terms. If you do not agree, please do not use our Website or
          Services.
        </Typography>

        {[
          {
            title: "1. Purpose of the Website and Services",
            body: `Atttic.com serves as a platform to describe and showcase Xculptor 3Dtech Private Limited’s offerings under the Atttic brand label. Atttic-branded solutions enable prospective customers (typically consumer brands) to catalogue 3D models of physical products and publish them in customized scenes.

            The Website and associated visuals are intended to illustrate potential use cases and features. Any resemblance to actual products or designs owned by other entities is purely coincidental and not intended to imply association.`,
          },
          {
            title: "2. Data Collection and Use",
            body: `We may collect information from you in several ways, including:

- Information you voluntarily submit through forms, such as “Contact Us”
- Information automatically collected during your visits (e.g., IP address, device type, browser information, usage data, cookies, and similar tracking technologies)

We use this information to:

- Provide, improve, and maintain the Website and Services
- Respond to inquiries and communicate with you
- Conduct marketing and promotional outreach
- Analyze usage and trends to improve performance and user experience
- Comply with legal obligations and protect our rights

Please refer to our Privacy Policy for further details on how we collect, use, and protect your information.`,
          },
          {
            title: "3. Intellectual Property",
            body: `Unless otherwise stated, all content on the Website and in our Services — including but not limited to text, images, graphics, logos, and software — is the property of Xculptor 3Dtech Private Limited or its licensors and is protected by applicable intellectual property laws.

You may not reproduce, distribute, modify, create derivative works of, publicly display, or exploit any part of our content without our prior written permission.`,
          },
          {
            title: "4. Use of Website and Services",
            body: `You agree to use the Website and Services only for lawful purposes and in accordance with these Terms. You must not:

- Use the Website or Services in any way that violates applicable laws or regulations
- Interfere with or disrupt the Website’s operation or security
- Attempt unauthorized access to any part of the Website or related systems`,
          },
          {
            title: "5. User Submissions and Communications",
            body: `If you submit information or materials to us (e.g., via forms, emails, or other channels), you grant us a non-exclusive, worldwide, royalty-free license to use such information to respond to you and provide relevant Services.

You agree that we may contact you via email, phone, WhatsApp, or other channels in response to your inquiry and for future marketing or informational purposes. You can opt out of marketing communications at any time as described in our Privacy Policy.`,
          },
          {
            title: "6. Disclaimers",
            body: `The Website and Services are provided on an “as is” and “as available” basis. We make no warranties or representations of any kind, express or implied, regarding the accuracy, completeness, or suitability of the content provided.

We do not warrant that the Website or Services will be uninterrupted, error-free, or free of viruses or other harmful components.`,
          },
          {
            title: "7. Limitation of Liability",
            body: `To the fullest extent permitted by law, Xculptor 3Dtech Private Limited and its affiliates shall not be liable for any indirect, incidental, consequential, special, or punitive damages, or for any loss of profits or revenues, whether incurred directly or indirectly, arising from your use of or inability to use the Website or Services.`,
          },
          {
            title: "8. Indemnification",
            body: `You agree to indemnify, defend, and hold harmless Xculptor 3Dtech Private Limited, its affiliates, and their respective officers, directors, employees, and agents from any claims, liabilities, damages, losses, or expenses (including reasonable legal fees) arising out of your use of the Website or Services or violation of these Terms.`,
          },
          {
            title: "9. Modifications to Terms",
            body: `We reserve the right to modify these Terms at any time. Any changes will be posted on this page with an updated effective date. Your continued use of the Website or Services following the posting of changes signifies your acceptance of those changes.`,
          },
          {
            title: "10. Governing Law",
            body: `These Terms shall be governed by and construed in accordance with the laws of India, without regard to its conflict of law provisions.

Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts in Mumbai (MH, India).`,
          },
          {
            title: "11. Contact Us",
            body: `If you have any questions about these Terms, please contact us at contactus@atttic.com`,
          },
        ].map((section, index) => (
          <Box key={index} sx={sectionStyle}>
            <Typography variant="h6" sx={headingStyle}>
              {section.title}
            </Typography>
            {section.body.split("\n").map((line, idx) => (
              <Typography key={idx} sx={paragraphStyle}>
                {line.trim()}
              </Typography>
            ))}
          </Box>
        ))}
      </Container>
    </Box>
  );
};

export default TermsAndConditions;
